
import collect from 'collect.js'
import Times from '@/assets/icons/fontawesome/light/times.svg?inline'
import ChevronLeft from '@/assets/icons/fontawesome/light/chevron-left.svg?inline'
import ChevronRight from '@/assets/icons/fontawesome/light/chevron-right.svg?inline'
import MapMarkedAlt from '@/assets/icons/fontawesome/regular/map-marked-alt.svg?inline'
import InfoCircle from '@/assets/icons/fontawesome/duotone/info-circle.svg?inline'

export default {
  components: {
    Times,
    ChevronLeft,
    ChevronRight,
    MapMarkedAlt,
    InfoCircle,
  },

  asyncData({
    $axios,
    app,
    i18n,
    params,
    query,
    redirect,
    $config: { baseURL },
  }) {
    let checkIn = app.$moment().locale('en').format('YYYY-MM-DD')
    let checkOut = app
      .$moment()
      .locale('en')
      .add(1, 'days')
      .format('YYYY-MM-DD')
    let guests = [{ adults: 2, children: [] }]

    if (
      query.check_in &&
      query.check_in >= app.$moment().locale('en').format('YYYY-MM-DD')
    ) {
      checkIn = app.$moment(query.check_in).locale('en').format('YYYY-MM-DD')
      if (query.check_out && query.check_out > query.check_in) {
        if (
          app
            .$moment(query.check_out)
            .diff(app.$moment(query.check_in), 'days') > 30
        ) {
          checkOut = app
            .$moment(checkIn)
            .locale('en')
            .add(30, 'days')
            .format('YYYY-MM-DD')
        } else {
          checkOut = app
            .$moment(query.check_out)
            .locale('en')
            .format('YYYY-MM-DD')
        }
      } else {
        checkOut = app
          .$moment(query.check_in)
          .locale('en')
          .add(1, 'days')
          .format('YYYY-MM-DD')
      }
    }

    if (query.check_out && query.check_out > checkIn) {
      if (
        app.$moment(query.check_out).diff(app.$moment(checkIn), 'days') > 30
      ) {
        checkOut = app
          .$moment(checkIn)
          .locale('en')
          .add(30, 'days')
          .format('YYYY-MM-DD')
      } else {
        checkOut = app
          .$moment(query.check_out)
          .locale('en')
          .format('YYYY-MM-DD')
      }
    }

    if (query.guests) {
      guests = query.guests.split('|').map((r) => {
        return {
          adults: r.split(',').filter((v) => v === 'a').length,
          children: r.split(',').filter((v) => v > 0),
        }
      })
    }

    return $axios
      .$get(`/v3/travolutionary/${params.countrySlug}/${params.hotelId}`, {
        params: {
          facilities: true,
          country: true,
          // city: true,
          images: true,
          image: true,
          remarks: true,
        },
      })
      .then((response) => {
        return {
          hotel: response.data,
          start: checkIn,
          end: checkOut,
          rooms: guests,
          showAll: query.all || false,
          activeFilters: query.filters || '',
          schemaBreadcrumbList: {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: i18n.t('Travelor'),
                item: baseURL + app.localePath('/'),
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: i18n.t('Hotels'),
                item: baseURL + app.localePath('hotels'),
              },
              {
                '@type': 'ListItem',
                position: 3,
                name: i18n.t('Hotels in {destination}', {
                  destination: response.data.country.title,
                }),
                item:
                  baseURL +
                  app.localePath({
                    name: 'hotels-destination-countrySlug',
                    params: { countrySlug: response.data.country.slug },
                  }),
                // }, {
                //   '@type': 'ListItem',
                //   position: 4,
                //   name: i18n.t('Hotels in {destination}', {
                //     destination: response.data.city.title
                //   }),
                //   item: baseURL + app.localePath({
                //     name: 'hotels-destination-countrySlug-destinationSlug',
                //     params: {
                //       countrySlug: response.data.city.country.slug,
                //       destinationSlug: response.data.city.slug
                //     }
                //   })
              },
              {
                '@type': 'ListItem',
                position: 4,
                name: response.data.title,
                item:
                  baseURL +
                  app.localePath({
                    name: 'hotels-place-countrySlug-hotelId',
                    params: {
                      countrySlug: response.data.country.slug,
                      // destinationSlug: response.data.city.slug,
                      hotelId: response.data.id,
                    },
                  }),
              },
            ],
          },
          schemaHotel: {
            '@context': 'http://schema.org',
            '@type': 'Hotel',
            name: response.data.title,
            url:
              baseURL +
              app.localePath({
                name: 'hotels-place-countrySlug-hotelId',
                params: {
                  countrySlug: response.data.country.slug,
                  // destinationSlug: response.data.city.slug,
                  hotelId: response.data.id,
                },
                query: {
                  fid: query.fid || '',
                },
              }),
            image: response.data.image
              ? response.data.image.url
              : '/images/placeholder.jpg',
            // description: response.data.description,
            telephone: '+972 3 677 0099',
            email: 'reservations@travelor.com',
            address: {
              '@type': 'PostalAddress',
              streetAddress: response.data.address,
              // addressLocality: response.data.city.title,
              addressCountry: response.data.country.title,
              postalCode: response.data.postal_code,
            },
            geo: {
              '@type': 'GeoCoordinates',
              latitude: response.data._geoloc.lat,
              longitude: response.data._geoloc.lng,
            },
            hasMap: `https://www.google.com/maps/place/${response.data._geoloc.lat},${response.data._geoloc.lng}`,
            // hasMap: `https://maps.googleapis.com/maps/api/staticmap?zoom=15&center=${response.data._geoloc.lat},${response.data._geoloc.lng}&markers=color:blue%7c${response.data._geoloc.lat},${response.data._geoloc.lng}&sensor=false&size=1600x1200`,
            starRating: {
              '@type': 'http://schema.org/Rating',
              ratingValue: response.data.star_rating,
            },
            priceRange: i18n.t('Competitive prices'),
          },
        }
      })
      .catch(() => {})
  },
  data() {
    return {
      filters: [],
      response: [],
      search: {},
      addedToCartResultCode: '',
      signal: null,
      controller: null,
      remarks: null,
      cancellation: null,
      loading: false,
      searching: false,
      loadingRemarks: false,
      searchBox: true,
      destroying: false,
      reviewsFull: null,
      reviewsUrl: null,
      modalOpen: false,
      modalMap: false,
      time: null,
      errors: {},
      cartSending: false,
    }
  },
  head() {
    return {
      title: this.hotel.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$i18n.t(
            'Competitive prices, personal and professional service in booking hotels, flights and other tourism products.',
          ),
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: `${this.$i18n.t('Hotels')}, ${this.hotel.title}`,
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.formatStars(this.hotel.star_rating).length
            ? this.formatStars(this.hotel.star_rating) + ' ' + this.hotel.title
            : this.hotel.title,
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.hotel.address + ', ' + this.hotel.country.title,
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: this.hotel.image
            ? this.hotel.image.url
            : '/images/placeholder.jpg',
        },
        {
          hid: 'og:image:width',
          property: 'og:image:width',
          content: this.hotel.image ? this.hotel.image.width : '1000',
        },
        {
          hid: 'og:image:height',
          property: 'og:image:height',
          content: this.hotel.image ? this.hotel.image.height : '664',
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: this.schemaHotel.url,
        },
      ],
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        {
          innerHTML: JSON.stringify(this.schemaBreadcrumbList),
          type: 'application/ld+json',
        },
        {
          innerHTML: JSON.stringify(this.schemaHotel),
          type: 'application/ld+json',
        },
        {
          src: this.$config.trustyouIframeResizer,
        },
      ],
    }
  },
  computed: {
    staticMap() {
      if (this.mapDriver === 'mapbox') {
        return this.colorMode === 'dark'
          ? `https://api.mapbox.com/styles/v1/mapbox/dark-v10/static/geojson(%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B${this.hotel._geoloc.lng}%2C${this.hotel._geoloc.lat}%5D%7D)/${this.hotel._geoloc.lng},${this.hotel._geoloc.lat},15/450x300?access_token=${this.$config.mapboxglAccessToken}`
          : `https://api.mapbox.com/styles/v1/mapbox/streets-v11/static/geojson(%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B${this.hotel._geoloc.lng}%2C${this.hotel._geoloc.lat}%5D%7D)/${this.hotel._geoloc.lng},${this.hotel._geoloc.lat},15/450x300?access_token=${this.$config.mapboxglAccessToken}`
      }

      return `https://maps.googleapis.com/maps/api/staticmap?zoom=17&center=${
        this.hotel._geoloc.lat
      },${this.hotel._geoloc.lng}&maptype=roadmap&markers=color:red%7c${
        this.hotel._geoloc.lat
      },${this.hotel._geoloc.lng}&sensor=false&size=450x300&key=${
        this.$config.googleApiKey
      }&map_id=${
        this.colorMode === 'dark'
          ? this.$config.googleMapDarkId
          : this.$config.googleMapLightId
      }`
    },
    types() {
      let results = []

      if (this.showAll) {
        results = collect(this.response)
      } else {
        results = collect(this.response)
          .groupBy('key')
          .map((item, key) => {
            return item.sortBy('price.amount').first()
          })
          .values()
      }

      return results
        .map((result) => {
          const filters = collect([])

          filters.push({
            key: 'cancellation_' + result.cancellation.type,
            category: 'cancellation',
            name: result.cancellation.type,
            active: true,
          })

          collect(result.items).each((room) => {
            filters.push({
              key: 'bedding_' + room.bedding,
              category: 'bedding',
              name: room.bedding,
              active: true,
            })
            filters.push({
              key: 'board_' + room.board,
              category: 'board',
              name: room.board,
              active: true,
            })
          })

          return {
            name: collect(result.items).pluck('name').unique().join(', '),
            filters: filters.unique().all(),
            ...result,
          }
        })
        .filter((result) => {
          const filters = {
            cancellation: true,
            bedding: true,
            board: true,
          }

          const filtersCategories = collect(this.filters).groupBy('category')
          const itemCategories = collect(result.filters).groupBy('category')

          filtersCategories.each((categry, key) => {
            const actives = categry.filter((filter) => filter.active)

            if (actives.count()) {
              filters[key] = actives
                .pluck('key')
                .all()
                .includes(itemCategories.all()[key].first().key)
            }
          })

          return collect(filters).filter().count() === 3
        })
        .sortBy('price.amount')
        .groupBy('name')
        .map((item, key) => {
          return {
            name: key,
            results: item.items,
          }
        })
        .values()
        .all()
    },
    hotelFacilities() {
      return collect(this.hotel.facilities)
        .groupBy('type')
        .map((groupFacility) => {
          return groupFacility
            .pluck('name')
            .map((facility) => {
              return {
                name: facility,
                title: this.facilities[facility] || facility,
              }
            })
            .all()
        })
        .all()
    },
  },
  watch: {
    priceDisplay(newDisplay, oldDisplay) {
      if (this.isAgent && newDisplay !== oldDisplay) {
        this.createSession()
      }
    },
    country(newCountry, oldCountry) {
      if (newCountry !== oldCountry) {
        this.createSession()
      }
    },
    currency(newCurrency, oldCurrency) {
      if (newCurrency !== oldCurrency) {
        this.getSession(this.$route.query.session, this.$route.query)
      }
    },
    response(newResponse, oldResponse) {
      if (newResponse !== oldResponse) {
        const filters = collect([])
        const activeFilters = this.activeFilters.split(',')

        collect(newResponse).each((item) => {
          filters.push({
            key: 'cancellation_' + item.cancellation.type,
            category: 'cancellation',
            name: item.cancellation.type,
            active: activeFilters.includes(
              'cancellation_' + item.cancellation.type,
            ),
          })

          collect(item.items).each((item) => {
            filters.push({
              key: 'bedding_' + item.bedding,
              category: 'bedding',
              name: item.bedding,
              active: activeFilters.includes('bedding_' + item.bedding),
            })
            filters.push({
              key: 'board_' + item.board,
              category: 'board',
              name: item.board,
              active: activeFilters.includes('board_' + item.board),
            })
          })
        })

        this.filters = filters
          .unique('key')
          .filter((filter) => filter.name)
          .sortBy('category')
          .all()
      }
    },
    filters: {
      deep: true,
      handler(newFilters) {
        const data = Object.assign({}, this.$route.query)

        data.filters = collect(newFilters)
          .filter((item, key) => {
            return item.active
          })
          .pluck('key')
          .implode(',')

        this.activeFilters = data.filters
        this.$router.replace({ query: data }).catch(() => {})
      },
    },
    '$route.query': {
      handler(newQuery, oldQuery) {
        const search = collect(newQuery).only([
          'check_in',
          'check_out',
          'country',
          // 'currency',
          'guests',
        ])

        const oldSearch = collect(oldQuery).only([
          'check_in',
          'check_out',
          'country',
          // 'currency',
          'guests',
        ])

        if (
          oldSearch.values().all().toString() !==
          search.values().all().toString()
        ) {
          this.start = newQuery.check_in
          this.end = newQuery.check_out
          return this.createSession()
        }
      },
    },
    modalOpen(value) {
      if (!value) {
        this.remarks = null
      }
    },
  },
  mounted() {
    if (this.$route.query.session) {
      this.getSession(this.$route.query.session)
      this.getReviews(this.$route.query.session)
    } else if (
      this.$route.query.check_in &&
      this.$route.query.check_out &&
      this.$route.query.guests
    ) {
      this.createSession()
    } else {
      this.searchBox = true
    }

    // this.addSearch({
    //   router: this.$route.fullPath,
    //   params: this.$route.query,
    //   country: this.hotel.city.country.title,
    //   name: this.hotel.title,
    //   check_in: this.start,
    //   check_out: this.end,
    //   image: this.hotel.images,
    //   aggregator: this.aggregator,
    //   destination: {
    //     type: 'hotel',
    //     slug: this.hotel.slug,
    //     city: this.hotel.city,
    //     id: this.hotel.id,
    //     name: this.hotel.title
    //   }
    // })
  },
  destroyed() {
    this.destroying = true
  },
  methods: {
    async createSession(count = 1) {
      if (this.controller) {
        this.controller.abort()
      }

      if (this.destroying) {
        return
      }

      // this.searchBox = false
      this.response = []
      this.loading = true
      this.searching = true

      try {
        await this.$axios
          .$post('/v3/sessions', {
            aggregator: this.hotel.aggregator,
            type: 'hotel',
            ids: this.hotel.id,
            check_in: this.start,
            check_out: this.end,
            country: this.country,
            currency: this.currency,
            fid: this.getFid,
            net: 1,
            // net: this.priceDisplay === 'net' ? 1 : 0,
            guests: this.rooms
              .map((r) => {
                const room = []
                for (let a = 0; a < r.adults; a++) {
                  room.push('a')
                }
                for (let c = 0; c < r.children.length; c++) {
                  room.push(r.children[c])
                }
                return room.toString().replace(/,/g, ':')
              })
              .toString()
              .replace(/,/g, '|')
              .replace(/:/g, ','),
          })
          .then(async (response) => {
            this.onSessionChange(response.session)
            const options = collect(this.$route.query)
              .only(['sort_by', 'sort', 'min_price', 'min_price', 'stars'])
              .all()

            await this.getSession(response.session, options, true, count)
            await this.getReviews(response.session)
          })
      } catch (err) {
        // this.$sentry.captureException(err)
      }
    },
    async getSession(
      session,
      options = {},
      loading = true,
      count = 1,
      countP = 1,
    ) {
      // this.searchBox = false

      if (this.destroying) {
        return
      }

      this.loading = loading
      this.searching = true
      this.controller = new AbortController()

      try {
        await this.$axios
          .$get(`/v3/session/${session}/hotel/${this.hotel.id}/details`, {
            signal: this.controller.signal,
            progress: false,
            params: {
              currency: this.currency,
            },
          })
          .then((response) => {
            this.onSessionChange(response.session)
            this.search = response.search
            this.response = response.data

            if (response.status === 'error' || response.error) {
              this.loading = false
            }

            if ((response.status === 'error' || response.error) && count < 5) {
              return this.createSession(count)
            }

            if (response.status === 'running' && count < 20) {
              setTimeout(async () => {
                if (response.session === this.$route.query.session) {
                  await this.getSession(
                    response.session,
                    options,
                    this.loading,
                    count + 1,
                  )
                }
              }, 3000)
            } else if (response.meta.status === 'running' && countP < 20) {
              setTimeout(async () => {
                if (response.session === this.$route.query.session) {
                  await this.getSession(
                    response.session,
                    options,
                    this.loading,
                    count,
                    countP + 1,
                  )
                }
              }, 3000)
            } else {
              this.loading = false
            }

            if (response.data.length) {
              this.time = this.$moment
                .utc(response.created_at)
                .add(this.$config.sessionLifetime, 'minutes')
                .diff(this.$moment.utc(), 'millisecond')
            }
          })
      } catch (err) {
        this.loading = false

        if (
          this.$route.query.check_in &&
          this.$route.query.check_out &&
          this.$route.query.guests &&
          typeof err.response.data === 'object' &&
          err.response.data.errors?.session
        ) {
          this.createSession(count)
        }
      }
    },
    async getReviews(session) {
      if (this.destroying) {
        return
      }

      try {
        await this.$axios
          .$get(`/v3/session/${session}/hotel/${this.hotel.id}/reviews`, {
            progress: false,
          })
          .then((response) => {
            if (response.data) {
              this.reviewsUrl = response.data.data.url + '&iframe_resizer=true'
              if (typeof window.iFrameResize !== 'undefined') {
                this.$nextTick(() => {
                  window.iFrameResize({}, '#hotelReviews')
                })
              }
              this.reviewsFull = response.data.data.full
            }
          })
      } catch (err) {}
    },
    async getRemarks(code) {
      this.remarks = null
      this.cancellation = null
      this.modalOpen = true
      this.loadingRemarks = true

      try {
        await this.$axios
          .$get(
            `/v3/session/${this.$route.query.session}/hotel/${this.hotel.id}/results/${code}/remarks`,
            {
              progress: false,
            },
          )
          .then((response) => {
            this.remarks = response.data.remarks
            this.cancellation = response.data.cancellation
          })
      } catch (err) {}

      this.loadingRemarks = false
    },
    async openCartDialog(result) {
      const windowReference = window.open('', '_blank')
      this.errors = {}
      this.addedToCartResultCode = result.code
      this.cartSending = true
      const data = {
        type: 'hotel',
        data: {
          result,
          search: this.search,
          session: this.$route.query.session,
          hotel_id: this.hotel.id,
        },
      }

      try {
        await this.$axios
          .post('/v3/carts/data', data)
          .then((response) => {
            this.cartSending = false
            windowReference.location.href = `${this.$config.salesDomain}/${this.$i18n.locale === 'he' ? 'he' : 'en'}/${response.data}`
          })
          .catch(() => {
            this.errors = { message: 'Something went wrong. Please try again.' }
          })
      } catch (err) {
        // this.$sentry.captureException(err)
      } finally {
        this.cartSending = false
      }
    },
    filter(filter) {
      filter.active = !filter.active
    },
    resetFilters() {
      collect(this.filters).each((filter) => {
        if (filter.active) {
          filter.active = false
        }
      })
    },
    onSessionChange(session) {
      const data = Object.assign({}, this.$route.query)

      data.session = session

      this.$router.replace({ query: data }).catch(() => {})
    },
  },
}
